var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("validation-observer", {
          ref: "AddTemplateForm",
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (ref) {
                var invalid = ref.invalid
                return [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.formSubmitted($event)
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Template Name",
                                    "label-for": "mc-Template-name",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "Name",
                                      vid: "Name",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "mc-Template-name",
                                                  placeholder: "Template Name",
                                                },
                                                model: {
                                                  value: _vm.template.name,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.template,
                                                      "name",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "template.name",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Platform Type",
                                    "label-for": "platform-type",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Platform Type",
                                      vid: "Platform Type",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("v-select", {
                                                staticClass:
                                                  "item-selector-title",
                                                attrs: {
                                                  options: _vm.platformTypes,
                                                  label: "text",
                                                  multiple: "",
                                                  clearable: false,
                                                  placeholder:
                                                    "Select Platform Type",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value:
                                                    _vm.template.platformType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.template,
                                                      "platformType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "template.platformType",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-2", attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Subject",
                                    "label-for": "textarea-default",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: { name: "Subject", vid: "Subject" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "textarea-default",
                                                  type: "text",
                                                  placeholder: "Subject",
                                                },
                                                model: {
                                                  value: _vm.template.subject,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.template,
                                                      "subject",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "template.subject",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-2", attrs: { cols: "12" } },
                            [
                              _c("span", [_vm._v("Template Content")]),
                              _c("validation-provider", {
                                attrs: { name: "Content", vid: "Content" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c(
                                            "quill-editor",
                                            {
                                              attrs: {
                                                options: _vm.editorOption,
                                              },
                                              model: {
                                                value: _vm.template.body,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.template,
                                                    "body",
                                                    $$v
                                                  )
                                                },
                                                expression: "template.body",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: {
                                                    slot: "toolbar",
                                                    id: "toolbar",
                                                  },
                                                  slot: "toolbar",
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    { staticClass: "ql-bold" },
                                                    [_vm._v("Bold")]
                                                  ),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass: "ql-italic",
                                                    },
                                                    [_vm._v("Italic")]
                                                  ),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "ql-underline",
                                                    },
                                                    [_vm._v("Underline")]
                                                  ),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass: "ql-strike",
                                                    },
                                                    [_vm._v("Strike")]
                                                  ),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "ql-blockquote",
                                                    },
                                                    [_vm._v("Quote")]
                                                  ),
                                                  _c("button", {
                                                    staticClass: "ql-list",
                                                    attrs: { value: "ordered" },
                                                  }),
                                                  _c("button", {
                                                    staticClass: "ql-list",
                                                    attrs: { value: "bullet" },
                                                  }),
                                                  _c("button", {
                                                    staticClass: "ql-indent",
                                                    attrs: { value: "-1" },
                                                  }),
                                                  _c("button", {
                                                    staticClass: "ql-indent",
                                                    attrs: { value: "+1" },
                                                  }),
                                                  _c("button", {
                                                    staticClass: "ql-script",
                                                    attrs: { value: "sub" },
                                                  }),
                                                  _c("button", {
                                                    staticClass: "ql-script",
                                                    attrs: { value: "super" },
                                                  }),
                                                  _c("button", {
                                                    staticClass:
                                                      "ql-background",
                                                  }),
                                                  _c(
                                                    "select",
                                                    { staticClass: "ql-font" },
                                                    [
                                                      _c("option", {
                                                        attrs: {
                                                          selected: "selected",
                                                        },
                                                      }),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "serif",
                                                          },
                                                        },
                                                        [_vm._v("serif")]
                                                      ),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "monospace",
                                                          },
                                                        },
                                                        [_vm._v("monospace")]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "select",
                                                    {
                                                      staticClass: "ql-header",
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "1" },
                                                        },
                                                        [_vm._v("Heading 1")]
                                                      ),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "2" },
                                                        },
                                                        [_vm._v("Heading 2")]
                                                      ),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "3" },
                                                        },
                                                        [_vm._v("Heading 3")]
                                                      ),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "4" },
                                                        },
                                                        [_vm._v("Heading 4")]
                                                      ),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "5" },
                                                        },
                                                        [_vm._v("Heading 5")]
                                                      ),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "6" },
                                                        },
                                                        [_vm._v("Heading 6")]
                                                      ),
                                                      _c("option", {
                                                        attrs: { selected: "" },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "select",
                                                    { staticClass: "ql-align" },
                                                    [
                                                      _c("option", {
                                                        attrs: { selected: "" },
                                                      }),
                                                      _c("option", {
                                                        attrs: {
                                                          value: "center",
                                                        },
                                                      }),
                                                      _c("option", {
                                                        attrs: {
                                                          value: "right",
                                                        },
                                                      }),
                                                      _c("option", {
                                                        attrs: {
                                                          value: "justify",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "button",
                                                    { staticClass: "ql-image" },
                                                    [_vm._v("Image")]
                                                  ),
                                                  _c(
                                                    "button",
                                                    { staticClass: "ql-video" },
                                                    [_vm._v("Video")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-2", attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Upload Media",
                                    "label-for": "media-upload",
                                  },
                                },
                                [
                                  _c("b-form-file", {
                                    ref: "fileInput",
                                    attrs: {
                                      id: "media-upload",
                                      multiple: "",
                                      accept: _vm.acceptFileTypes,
                                    },
                                    on: { change: _vm.handleFileUpload },
                                  }),
                                ],
                                1
                              ),
                              _vm.previewImages.length
                                ? _c(
                                    "div",
                                    { staticClass: "preview-container" },
                                    [
                                      _c("h5", [_vm._v("Selected Images:")]),
                                      _c(
                                        "b-row",
                                        _vm._l(
                                          _vm.previewImages,
                                          function (image, index) {
                                            return _c(
                                              "b-col",
                                              {
                                                key: index,
                                                staticClass: "mb-2",
                                                attrs: { cols: "2" },
                                              },
                                              [
                                                _c(
                                                  "b-card",
                                                  {
                                                    staticClass: "preview-card",
                                                  },
                                                  [
                                                    _c("b-img", {
                                                      staticClass:
                                                        "preview-image",
                                                      attrs: {
                                                        src: image.src,
                                                        alt: "Preview Image",
                                                      },
                                                    }),
                                                    _c(
                                                      "b-button",
                                                      {
                                                        staticClass:
                                                          "mt-1 w-100",
                                                        attrs: {
                                                          variant: "danger",
                                                          size: "sm",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeImage(
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(" Remove ")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "submit",
                                variant: "primary",
                                disabled: invalid,
                              },
                            },
                            [_vm._v("Submit")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }